import type { Feature } from 'geojson'
import type L from 'leaflet'
import { GeoJSON, LayersControl } from 'react-leaflet'
import { EligibilityArea } from '../../types/apiModels'

export const getEligibilityLayerStyle = (feature?: Feature) => ({
  color: feature?.properties?.color,
  fillColor: feature?.properties?.color,
  weight: 2,
  opacity: 1,
  fillOpacity: 0.4,
})

export const bindEligibilityTooltip = (feature: Feature, layer: L.Layer) => {
  if (feature?.properties?.label) layer.bindTooltip(feature.properties.label, { sticky: true })
}

interface EligibilityLayersProps {
  eligibilityAreas?: EligibilityArea[] | null
}

// LayersControl.Overlay toggling works by calling map.removeLayer(), which does not empty a
// named Pane's DOM container (see src/components/Map/LayersControl.tsx header comment) — so
// these overlays must NOT be wrapped in <Pane> or hiding them would leave the layer visible.
const EligibilityLayers: React.FC<EligibilityLayersProps> = ({ eligibilityAreas }) => {
  if (!eligibilityAreas?.length) return null

  return (
    <>
      {eligibilityAreas.map(area => (
        <LayersControl.Overlay
          key={area.properties.id ?? area.properties.label}
          name={area.properties.label}
        >
          <GeoJSON
            data={area}
            style={getEligibilityLayerStyle}
            onEachFeature={bindEligibilityTooltip}
          />
        </LayersControl.Overlay>
      ))}
    </>
  )
}

export default EligibilityLayers
